import { Component, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../shared/services/api.service';
import { NewUserComponent } from './new-user/new-user.component';
import { ColDef } from 'ag-grid-community';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  standalone: false,
  styleUrls: ['./users.component.scss']
})
export class UsersComponent {


  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  content: any;
  type = 'currency';
  apiUrl: any;

  columnDefs: ColDef[] = [
    {
      headerName: 'Action',
      field: 'action',
      width: 150,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-outline-primary', 'ps-4', 'pe-4', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Name',
      field: 'username',
      editable: false,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Email Id',
      field: 'email',
      editable: false,
      sortable: true,
      filter: true,
      width: 250
    },
    {
      headerName: 'Mobile No',
      field: 'phone',
      editable: false,
      sortable: true,
      filter: true,
    },

  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private zone: NgZone,
    private _auth: AuthService
  ) { }

  ngOnInit(): void {

  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {

      vm.gridApi.sizeColumnsToFit();
    }
    this.gridApi.sizeColumnsToFit();
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const user = vm._auth.getUser();
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        // vm.apiUrl = '/users/v1/list';
         this.apiUrl = '/partners/auth/partner-users?' +  'partnerIdMongoDBID_like=' + user.partnerId._id + '&_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        if (params.sortModel && params.sortModel.length > 0) {
          const sortFields = params.sortModel.map(s => s.colId).join(',');
          const sortOrders = params.sortModel.map(s => s.sort).join(',');
          vm.apiUrl = vm.apiUrl + '&_sort=' + encodeURIComponent(sortFields) + '&_order=' + encodeURIComponent(sortOrders);
        }
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            params.successCallback(res.data, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onAddNew() {
    const vm = this;
    const modalRef = vm._modal.open(NewUserComponent, {
      backdrop: "static",
      size: "xl",
    });
    modalRef.componentInstance.onSave.subscribe(() => {
      vm.gridApi.refreshInfiniteCache();
    });
  }

  onEdit(data: any) {
    const vm = this;
    vm.zone.run(() => {
      const modalRef = vm._modal.open(NewUserComponent, {
        backdrop: "static",
        size: "xl",
      });
      const userData = { ...data.data };
      modalRef.componentInstance.newUser = userData;
      modalRef.componentInstance.onSave.subscribe(() => {
        vm.gridApi.refreshInfiniteCache();
      });
    });
  }

}
